import { render, staticRenderFns } from "./CompanyEmailSetting.vue?vue&type=template&id=938fa24a&scoped=true"
import script from "./CompanyEmailSetting.vue?vue&type=script&lang=js"
export * from "./CompanyEmailSetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyEmailSetting.vue?vue&type=style&index=0&id=938fa24a&prod&lang=scss&scoped=true"
import style1 from "./CompanyEmailSetting.vue?vue&type=style&index=1&id=938fa24a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938fa24a",
  null
  
)

export default component.exports